import { RootState } from './types'

export const getAccessToken = (state: RootState) => state.applicationState.accessToken